import BulkTicketManagement from "../..";
import useBulkTicketManagementRouteService from "./service";

export default function ManageBulkTicketRoute() {
  const service = useBulkTicketManagementRouteService();
  return <BulkTicketManagement isOpenInModal={true} modalCloseHandler={service.closeHandler} />;
}
